import {Component, Input, OnInit} from '@angular/core';
import {CityService} from '@services/city.service';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-square-price-diff',
    templateUrl: './square-price-diff.component.html',
    styleUrls: ['./square-price-diff.component.scss']
})
export class SquarePriceDiffComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor(public cityService: CityService) {
    }

    ngOnInit() {
    }
}
